import moment from 'moment';

//https://blog.jayway.com/2017/07/13/open-pdf-downloaded-api-javascript/
//https://docs.microsoft.com/en-us/previous-versions/windows/internet-explorer/ie-developer/samples/hh779016(v=vs.85)?redirectedfrom=MSDN

/**
 * IE doesn't allow using a blob object directly instead it is necessary to use msSaveOrOpenBlob
 * For other browsers, create a link pointing to the ObjectURL containing the blob.
 */
export const downloadPdfFile = (blob, fileName) => {
  const pdfBlob = new Blob([blob], { type: 'application/pdf' });
  //IE
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(pdfBlob, fileName);
    return;
  }
  //Other browsers
  const data = window.URL.createObjectURL(pdfBlob);
  const link = document.createElement('a');
  link.href = data;
  link.download = fileName;
  link.click();
  setTimeout(function () {
    window.URL.revokeObjectURL(data);
  }, 100);
};

/**
 * IE doesn't allow using a blob object directly instead it is necessary to use msSaveOrOpenBlob
 * Do not revoke ObjectUrl when viewing blob file to enable user to dowload file via browser's download button
 * If the object is revoked, Chrome will return network error
 */
export const viewPdfFile = (blob, fileName) => {
  const pdfBlob = new Blob([blob], { type: 'application/pdf' });
  //IE
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(pdfBlob, fileName);
    return;
  }
  //Other browsers
  const data = window.URL.createObjectURL(pdfBlob);
  const openWindow = window.open(data);
  if (openWindow) {
    openWindow.focus();
  } else {
    console.warn(
      'The application can not open a new window due to browser pop-ups blocked.'
    );
  }
};

/**
 * IE doesn't allow using a blob object directly instead it is necessary to use msSaveOrOpenBlob
 */
export const printPdfFile = (blob, fileName) => {
  const pdfBlob = new Blob([blob], { type: 'application/pdf' });
  //IE
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(pdfBlob, fileName);
    return;
  }
  //Other browsers
  const data = window.URL.createObjectURL(pdfBlob);
  const openWindow = window.open(data);
  if (openWindow) {
    openWindow.focus();
    setTimeout(function () {
      openWindow.print();
    }, 100);
  } else {
    console.warn(
      'The application can not open a new window due to browser pop-ups blocked.'
    );
  }
};

export const getTaxInvoicePdfFileName = (adfitNo, startPeriod) => {
  return `TaxInvoice_${adfitNo.trim()}_${moment(startPeriod).format(
    'YYYY_MM'
  )}.pdf`;
};
